import { Box, Button, Section } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import TextInput from 'modules/core/components/Inputs/Text'
import TextArea from 'modules/core/components/Inputs/TextArea'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import type EnpsForm from 'modules/enps/store/models/Form'

interface Props {
  form: EnpsForm
}

function BasicInfo({ form: EnpsForm }: Props) {
  const canEdit = EnpsForm.policy.can('editEnpsForm')
  const disabled = !canEdit

  const form = useLazyRef<Form>(
    () =>
      new Form(EnpsForm.toJS(), {
        name: 'string',
        description: 'string',
      })
  ).current

  const formName = form.get('name')
  const formDescription = form.get('description')
  const formHasName = !!formName.value
  const enpsIsActive = EnpsForm.isActive
  const isNameOrDescriptionDirty = formName.isDirty || formDescription.isDirty

  const { performAction: submit, running } = useAsyncAction(() => form.save(EnpsForm))

  // TODO: check this event, as it will be triggered on name update too
  const onTrackingDescription = () => {
    EnpsForm.isDraft && track(trackingEvents.enps.saveDescriptionSettingsEnps)
    submit()
  }

  return (
    <Section.Form
      illustration="settings"
      title={i18n.t('enps.form.basic_info.title')}
      description={i18n.t('enps.form.basic_info.subtitle')}
      submitLabel={i18n.t('common.submit')}
    >
      <Box gap="s16">
        <Box gap="s8">
          <TextInput
            readonly={enpsIsActive}
            field={formName}
            label={i18n.t('enps.form.basic_info.name')}
          />
        </Box>
        <Box gap="s8">
          <TextArea
            readonly={enpsIsActive}
            field={formDescription}
            label={i18n.t('enps.form.basic_info.description')}
            placeholder={i18n.t('enps.form.basic_info.placeholder')}
          />
          {!enpsIsActive && isNameOrDescriptionDirty && (
            <Box alignItems="flexEnd">
              <Button
                disabled={disabled || running || !formHasName}
                onClick={onTrackingDescription}
              >
                {i18n.t('enps.form.configuration.save')}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Section.Form>
  )
}

export default observer(BasicInfo)
